import {Box, Button, Grid, makeStyles} from "@material-ui/core";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import TopBar from "../../components/Common/TopBar";
import PayrollAdjustmentTable from "../../components/PayrollAdjustment/PayRollTable/index";
import PayrollDailyLog from "../../components/PayrollAdjustment/PayrollDailyLog/index";
import PayrollHoursReview from "../../components/PayrollAdjustment/PayrollHoursReview/index";
import {handleOpenDeliveryAreaFormDialog, showAlertSnackbar} from "../../reducers/uiSlice";
import {useToken} from "../../utilities/hooks";
import _ from 'lodash';
import {getUserPreference} from "../../utilities/common";
import PublishIcon from "@material-ui/icons/Publish";
import AddIcon from "@material-ui/icons/Add";
import RefreshIcon from "@material-ui/icons/Refresh";
import {AddBoxOutlined} from "@material-ui/icons";
import CreateEditDialog from "../../components/DeliveryAreaManagement/CreateEditDialog";
import AssignmentDialog from "../../components/DeliveryAreaManagement/AssignmentDialog";
import FullscreenLoading from "../../components/Common/FullscreenLoading";
import UniDialog from "../../components/Common/UniDialog";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.default,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        margin: 0
    },
    appBarClasses: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: theme.spacing(1)
    },
    topBarButton: {
        marginLeft: theme.spacing(2),
        color: 'unset',
        '&:hover': {
            color: theme.palette.text.primary
        }
    },
    buttonGroupStyle: {
        textAlign: 'right',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2)
    },
}))

function PayrollAdjustment(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation('payrollAdjustment');
    const [manageIndex, setManageIndex] = useState('dailyLogSection');
    const tokenContents = useToken();
    const authorizedWarehouses = tokenContents.warehouse;
    const [isDataLoading, setIsDataLoading] = useState(false);

    const manageIndices = {
        dailyLogSection: {
          id: 0,
          text: t('daily_log')
        },
        hoursReviewSection: {
          id: 1,
          text: t('hours_review')
        },
        payRollSection: {
          id: 2,
          text: t('payroll_adjustment')
        }
      };
      
    const handleManageIndex = (event) => {
        setManageIndex(event.target.value);
    }

    return (
        <Box className={classes.root}>
            <TopBar
                title={t('payroll_adjustment_management')}
                buttonClasses={classes.topBarButton}
                appBarClasses={classes.appBarClasses}
                handleRadioChange={handleManageIndex}
                radios={manageIndices}
                radio={manageIndex}
            />
            <div hidden={manageIndex !== 'dailyLogSection'}>
                <PayrollDailyLog />
            </div>

            <div hidden={manageIndex !== 'hoursReviewSection'}>
                <PayrollHoursReview />
            </div>
            <div hidden={manageIndex !== 'payRollSection'}>
                <PayrollAdjustmentTable />
            </div>
        </Box>
    );
}

export default PayrollAdjustment;